let pjax
const APP = {
	// сет брейкпоинтов для js
	// должны совпадать с теми что в body:after
	mediaBreakpoint: {
		sm: 576,
		md: 768,
		lg: 992,
		xl: 1360,
		xxl: 1800,
	},
	cache: {},
	initOnceBefore: function() {
		APP.polyfills()
		document.documentElement.className =
			document.documentElement.className.replace("no-js", "js");
		topbar.show()
		APP.detectIE();
		APP.svgIcons();
		APP.viewportFix();
		APP.pjaxListeners();
	},

	initOnceLayout: function() {
		APP.closeOnFocusLost();
		APP.pjaxInit();
		APP.buttons();
		APP.feedbackModalForm();
		APP.loadImagesModalForm();
		APP.sendImagesModalForm();
		APP.initLoadIndicator();
	},

	initPage: function() {
		APP.lazyload();

		const myMask = new APP.Mask(".js-tel")
		myMask.init()

		APP.instafeed()

		APP.navHover();
		APP.mainSlider();
		APP.selectionsSlider();
		APP.catalogItemSlider();
		APP.catalogDetailedSlider();

		APP.downloadPhotos();
		APP.stiky()
		APP.catalogSelect();
		APP.catalogSidebarDropdown();
		APP.catalogSidebarCheckAll();
		APP.catalogSidebarOnCheck();

		APP.catalogLoadMore();
		APP.relatedLoadMore();
		APP.searchLoadMore();
		APP.initMap();

		// Dynamically update goodshare btns
		window._goodshare.reNewAllInstance();
	},

	initOnLoad: function() {
		topbar.hide()
	},

	buttons: function() {
		APP.documentOn('click', '.menu-trigger', function (e) {
			document.body.classList.toggle('nav-showed')
		})

		APP.documentOn('click', '.top-nav a', function () {
			document.body.classList.remove('nav-showed')
		});

		APP.documentOn('click', '.js-ajax-modal', function (e) {
			e.preventDefault();
			const myUrl = this.getAttribute('href')
			APP.ajaxModal({
				url: myUrl,
				data: null,
				type: 'GET',
				onOpen: function (modal) {
					const myMask = new APP.Mask(".js-tel")
					myMask.init()
				},
				onClose: function (modal) {
					// console.log('close');
				}
			})
		});

		APP.documentOn('click', '.js-modal-close', function (e) {
			e.preventDefault()
			APP.cache.tingleModal.close();
		});

	},

	closeOnFocusLost: function() {
		document.addEventListener('click', function(e) {
			const trg = e.target;
			if (!trg.closest(".header")) {
				document.body.classList.remove('nav-showed');
			}
		});
	},

	initLoadIndicator: function () {
		topbar.config({
			barColors: {
				'0': '#946707',
				'1.0': '#CDA222'
			},
		})
	},

	catalogSidebarDropdown: function () {
		Array.prototype.forEach.call(document.querySelectorAll('.sidebar__item-title'), function (item) {
			var toggleDropDown = function (elem) {
				elem.closest('.js-sidebar-item').classList.toggle('is-active');
			}
			item.addEventListener('click', function () {
				toggleDropDown(this)
				APP.updateStikySidebar()
			});
		});
	},

	catalogSidebarCheckAll: function () {
		Array.prototype.forEach.call(document.querySelectorAll('.js-check-all'), function (checkbox) {
			checkbox.addEventListener('change', function (e) {
				const inputs = this.closest('.js-check-list').querySelectorAll('input:not(.js-check-all)')
				for (var i = 0; i < inputs.length; i++) {
					if(this.checked == true) {
						inputs[i].checked = true;
					} else {
						inputs[i].checked = false;
					}
				}
			})
		});
	},

	catalogSidebarOnCheck: function () {
		const filter = document.getElementById('catalog-filter')
		if (!filter) { return }
		const init = () => {
			setAllChecked()
			filter.addEventListener('change', onChecked)
		}

		// если все чекобксы checked
		// сделать checked и первый
		const setAllChecked = () => {
			const checkList = filter.querySelectorAll('.js-check-list')
			for (var i = 0; i < checkList.length; i++) {
				const thatCheckList = checkList[i]
				const checkboxes = thatCheckList.querySelectorAll('input[type=checkbox]')
				const checkboxesChecked = thatCheckList.querySelectorAll('input[type=checkbox]:checked')
				const allChecked = (checkboxes.length - 1) == checkboxesChecked.length
				if (allChecked) {
					thatCheckList.querySelector('.js-check-all').checked = true
				}
			}
		}

		// при клике по чекбоксам формируем урл
		// и делаем ajax переход на соответствующую страницу
		const onChecked = function () {
			const checkboxes = filter.querySelectorAll('input[type=checkbox]')
			const filterAction = filter.getAttribute('action')
			const filters = [];
			for (var i = 0; i < checkboxes.length; i++) {
				const checkbox = checkboxes[i]
				if (checkbox.checked && !checkbox.hasClass('js-check-all')) {
					filters.push(checkbox.value)
				}
			}
			const filtersString = filters.join(',')
			let newPageUrl
			if (filtersString.length) {
				newPageUrl = `${filterAction}?category=${filtersString}`
			} else {
				newPageUrl = filterAction
			}

			// dev
			// pjax.loadUrl('catalog.html')
			// production
			pjax.loadUrl(newPageUrl)
		}
		init ();
	},

	catalogLoadMore: function () {
		const elements = {
			BTN_MORE: '.js-show-more',
			ITEMS_LIST: '.catalog__list',
			PRELOADER: '.catalog__preloader',
			ITEM_TEMPLATE: '#item-catalog',
			ALL_LOADED: '.catalog__all-loaded',
		}
		const states = {
			BTN_MORE_DISABLED: 'disabled',
		}

		const init = () => {
			const btns = document.querySelectorAll(elements.BTN_MORE)
			if (!btns.length) { return }
			setStartUrl()
			for (var i = 0; i < btns.length; i++) {
				btns[i].addEventListener('click', loadMore)
			}
			onScroll()
		}

		const loadMore = function(event) {
			event.preventDefault();
			if (this.hasClass(states.BTN_MORE_DISABLED)) { return }

			disableBtn(true)
			showPreloader(true)

			const myUrl = this.getAttribute('href')

			ajaxGet( myUrl, ajaxOnSuccess, ajaxOnError )
		}

		const setStartUrl = () => {
			const btn = document.querySelector(elements.BTN_MORE)
			let categoryFilter = ''
			let filteredParam = 0
			const startItems = document.querySelector(elements.ITEMS_LIST).children.length
			if (window.location.search) {
				const param = APP.findGetParameter('category')
				if (param.match('_cat')) {
					const re = /(\.[0-9]+)/g
					filteredParam = param.match(re) + ''
					filteredParam = filteredParam.replace(/\./g,'')
				} else {
					filteredParam = param
				}
				categoryFilter = filteredParam ? `&categories=${filteredParam}` : ''
			}
			const newUrl = `/api/v1/locations/?format=json&limit=8&offset=${startItems}${categoryFilter}`
			btn.setAttribute('href', newUrl)
		}

		const ajaxGet = (url, onSuccess, onError) => {
			var request = new XMLHttpRequest();
			request.open('GET', url, true);

			request.onload = function() {
				if (request.status >= 200 && request.status < 400) {
					// Success!
					var data = JSON.parse(request.responseText);
					onSuccess(data)
				} else {
					console.log('We reached our target server, but it returned an error');
					onError()
				}
			};

			request.onerror = function() {
				console.log('There was a connection error of some sort');
				onError()
			};

			request.send();
		}

		const ajaxOnSuccess = (data) => {
			const itemsContainer = document.querySelector(elements.ITEMS_LIST)
			const tmpl = getTemplate(elements.ITEM_TEMPLATE)
			const formatedData = formatData(data)
			const items = renderItems(tmpl, formatedData)
			if (items) {
				appendItems(items, itemsContainer)
				if (pjax) { pjax.refresh(itemsContainer) }
			}
			if (data.next) {
				disableBtn(false)
				updateLoadUrl(data.next)
				onScroll()
			} else {
				document.querySelector(elements.ALL_LOADED).classList.remove('d-none')
			}
			showPreloader(false)
		}

		const ajaxOnError = () => {
			showPreloader(false)
			disableBtn(false)
		}

		const renderItems = (template, data) => {
			let html = ''
			if (data.length == 0) {
				html = null
			} else {
				data.forEach(function (itemData, i) {
					const imagesArr = itemData.images_430x280
					itemData.images_430x280 = imagesArr
					html += _.template(template)(itemData);
				})
			}
			return html
		}

		const formatData = (data) => {
			const formatedData = data.results
			return formatedData
		}

		const appendItems = (items, container) => {
			container.insertAdjacentHTML('beforeend', items)
			APP.catalogItemSlider()
			APP.updateStikySidebar()
		}

		const getTemplate = (elem) => {
			const tmpl = document.querySelector(elem).innerHTML
			return tmpl
		}

		const updateLoadUrl = (url) => {
			document.querySelector(elements.BTN_MORE)
				.setAttribute('href', url)
		}

		const showPreloader = (boolean) => {
			const preloader = document.querySelector(elements.PRELOADER)
			if (boolean) {
				preloader.classList.remove('d-none')
			} else {
				preloader.classList.add('d-none')
			}
		}

		const disableBtn = (boolean) => {
			const btn = document.querySelector(elements.BTN_MORE)
			if (boolean) {
				btn.classList.add(states.BTN_MORE_DISABLED)
			} else {
				btn.classList.remove(states.BTN_MORE_DISABLED)
			}
		}

		const onScroll = () => {

			const btn = document.querySelector(elements.BTN_MORE)
			const offset = window.innerHeight / 2

			APP.cache.loadOnScroll = function () {
				if (APP.isScrolledIntoView(btn, offset)) {
					window.removeEventListener("scroll", APP.cache.loadOnScroll);
					btn.click()
				}
			}
			window.addEventListener('scroll', APP.cache.loadOnScroll)
		}

		init()

	},

	removeGlobalListeners: function () {
		if (APP.cache.loadOnScroll) {
			window.removeEventListener("scroll", APP.cache.loadOnScroll);
		}
	},

	relatedLoadMore: function () {
		const elements = {
			BTN_MORE: '.js-show-related',
			ITEMS_LIST: '.related__list',
			PRELOADER: '.related__preloader',
			ITEM_TEMPLATE: '#item-catalog',
			ALL_LOADED: '.related__all-loaded',
		}
		const states = {
			BTN_MORE_DISABLED: 'disabled',
		}

		const init = () => {
			if (!document.querySelector(elements.BTN_MORE)) { return }
			setStartUrl()
			APP.documentOn('click', elements.BTN_MORE, loadMore);
		}

		const loadMore = function(event) {
			event.preventDefault();
			if (this.hasClass(states.BTN_MORE_DISABLED)) { return }

			disableBtn(true)
			showPreloader(true)

			const myUrl = this.getAttribute('href')

			ajaxGet( myUrl, ajaxOnSuccess, ajaxOnError )
		}

		const setStartUrl = () => {
			const btn = document.querySelector(elements.BTN_MORE)
			const id = btn.getAttribute('data-location-id')
			const startItems = document.querySelector(elements.ITEMS_LIST).children.length
			const newUrl = `/api/v1/locations/?format=json&limit=8&offset=${startItems}&related=${id}`
			btn.setAttribute('href', newUrl)
		}

		const ajaxGet = (url, onSuccess, onError) => {
			var request = new XMLHttpRequest();
			request.open('GET', url, true);

			request.onload = function() {
				if (request.status >= 200 && request.status < 400) {
					// Success!
					var data = JSON.parse(request.responseText);
					onSuccess(data)
				} else {
					console.log('We reached our target server, but it returned an error');
					onError()
				}
			};

			request.onerror = function() {
				console.log('There was a connection error of some sort');
				onError()
			};

			request.send();
		}

		const ajaxOnSuccess = (data) => {
			const itemsContainer = document.querySelector(elements.ITEMS_LIST)
			const tmpl = getTemplate(elements.ITEM_TEMPLATE)
			const items = renderItems(tmpl, data.results)
			if (items) {
				appendItems(items, itemsContainer)
				if (pjax) { pjax.refresh(itemsContainer) }
			}
			if (data.next) {
				disableBtn(false)
				updateLoadUrl(data.next)
			} else {
				document.querySelector(elements.ALL_LOADED).classList.remove('d-none')
			}
			showPreloader(false)
		}

		const ajaxOnError = () => {
			showPreloader(false)
			disableBtn(false)
		}

		const renderItems = (template, data) => {
			let html = ''
			if (data.length == 0) {
				html = null
			} else {
				data.forEach(function (itemData, i) {
					const imagesArr = itemData.images_430x280
					itemData.images_430x280 = imagesArr
					html += _.template(template)(itemData);
				})
			}
			return html
		}

		const appendItems = (items, container) => {
			container.insertAdjacentHTML('beforeend', items)
			APP.catalogItemSlider()
		}

		const getTemplate = (elem) => {
			const tmpl = document.querySelector(elem).innerHTML
			return tmpl
		}

		const updateLoadUrl = (url) => {
			document.querySelector(elements.BTN_MORE)
				.setAttribute('href', url)
		}

		const showPreloader = (boolean) => {
			const preloader = document.querySelector(elements.PRELOADER)
			if (boolean) {
				preloader.classList.remove('d-none')
			} else {
				preloader.classList.add('d-none')
			}
		}

		const disableBtn = (boolean) => {
			const btn = document.querySelector(elements.BTN_MORE)
			if (boolean) {
				btn.classList.add(states.BTN_MORE_DISABLED)
			} else {
				btn.classList.remove(states.BTN_MORE_DISABLED)
			}
		}

		init()

	},

	searchLoadMore: function () {
		const elements = {
			BTN_MORE: '.js-search-more',
			ITEMS_LIST: '.search-result__list',
			ITEM: '.search-result__item',
			PRELOADER: '.search-result__preloader',
			ALL_LOADED: '.search-result__all-loaded',
		}
		const states = {
			BTN_MORE_DISABLED: 'disabled',
		}
		const btn = document.querySelector(elements.BTN_MORE)

		const init = () => {
			if (!btn) { return }
			setBtnHref(btn)
			btn.addEventListener('click', loadOnClick)
			onScroll()
		}

		const loadOnClick = function (e) {
			e.preventDefault()
			if (this.hasClass(states.BTN_MORE_DISABLED)) { return }

			const href = btn.getAttribute('href')
			showPreloader(true)
			disableBtn(true)
			APP.ajaxGet(href, onAjaxSuccess, onAjaxError)
		}

		const onAjaxSuccess = (response) => {
			const btn = document.querySelector(elements.BTN_MORE)
			const parser = new DOMParser();
			const doc = parser.parseFromString(response.responseText, "text/html");
			const newItems = doc.querySelectorAll('.search-result__item')
			const itemsContainer = document.querySelector('.search-result__list')
			for (var i = 0; i < newItems.length; i++) {
				itemsContainer.appendChild(newItems[i])
			}
			onScroll()
			APP.catalogItemSlider()
			if (pjax) { pjax.refresh(itemsContainer) }
			updateNextPageNum()
			setBtnHref()
			disableBtn(false)
			showPreloader(false)
		}

		const onAjaxError = () => {
			btn.classList.add(states.BTN_MORE_DISABLED)
			showPreloader(false)
			document.querySelector(elements.ALL_LOADED).classList.remove('d-none')
		}

		const showPreloader = (boolean) => {
			const preloader = document.querySelector(elements.PRELOADER)
			if (boolean) {
				preloader.classList.remove('d-none')
			} else {
				preloader.classList.add('d-none')
			}
		}

		const disableBtn = (boolean) => {
			const btn = document.querySelector(elements.BTN_MORE)
			if (boolean) {
				btn.classList.add(states.BTN_MORE_DISABLED)
			} else {
				btn.classList.remove(states.BTN_MORE_DISABLED)
			}
		}

		const setBtnHref = () => {
			const dataPage = btn.getAttribute('data-next-page')
			const href = `${location.pathname}${location.search}&page=${dataPage}`
			btn.setAttribute('href', href)
		}

		const updateNextPageNum = () => {
			let currentPage = btn.getAttribute('data-next-page') * 1
			const nextPage = currentPage + 1
			btn.setAttribute('data-next-page', nextPage)
		}

		const onScroll = () => {

			const btn = document.querySelector(elements.BTN_MORE)
			const offset = window.innerHeight / 2

			APP.cache.loadOnScroll = function () {
				if (APP.isScrolledIntoView(btn, offset)) {
					window.removeEventListener("scroll", APP.cache.loadOnScroll);
					btn.click()
				}
			}
			window.addEventListener('scroll', APP.cache.loadOnScroll)
		}

		init()

	},

	findGetParameter: function (parameterName) {
		var result = null,
		tmp = [];
		var items = location.search.substr(1).split("&");
		for (var index = 0; index < items.length; index++) {
			tmp = items[index].split("=");
			if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
		}
		return result;
	},

	instafeed: function () {
		const template = document.getElementById('instafeed-item')
		if (!template) { return }
		const feed = new Instafeed({
			get: 'user',
			userId: '6614240',
			clientId: 'c2edbe0f1aee427c8fe0c85404cc9210',
			accessToken : '6614240.c2edbe0.ee8e59d4c49744d59027ce89128b25e2',
			resolution: 'standard_resolution',
			limit: 12,
			sortBy: 'most-recent',
			template: template.innerHTML,
			links: false,
			after: function () {
				APP.gallerySlider();
			}
		});
		feed.run();
	},

	catalogSelect: function () {
		const select = document.querySelector('.js-catalog-select')
		if (!select) { return }
		select.addEventListener('change', function () {
			const id = parseInt(this.value)
			const sidebarItems = document.querySelectorAll('.js-sidebar-item')
			for (var i = 0; i < sidebarItems.length; i++) {
				const item = sidebarItems[i]
				item.classList.remove('is-active')
				if (item.getAttribute('data-id') == id) {
					item.classList.add('is-active')
				}
			}
		})
	},

	stiky: function () {
		var sickyElems = document.querySelectorAll('.js-stick-in-parent');
		APP.cache.stikys = []
		var init = function init(elem) {
			var sidebar = new StickySidebar(elem, {
				topSpacing: 10,
				bottomSpacing: 20
			});
			return sidebar;
		};

		Array.prototype.forEach.call(sickyElems, function (item) {
			var stiky = item;
			var startFrom = stiky.getAttribute('data-sticky-start');

			if (startFrom && APP.getScreenSize() >= startFrom) {
				APP.cache.stikys.push( init(stiky) )
			} else if (startFrom) {
				return;
			} else {
				APP.cache.stikys.push( init(stiky) )
			}
		});
	},

	updateStikySidebar: function () {
		if (APP.cache.stikys.length) {
			APP.cache.stikys.forEach(function (stiky) {
				stiky.updateSticky();
			})
		}
	},

	navHover: function () {
		const nav = document.querySelector('.js-top-nav')
		if (!nav) { return }
		let timer
		nav.onmouseenter = function () {
			clearTimeout(timer)
			timer = setTimeout(function() {
				nav.classList.add('top-nav--hover')
			}, 200);
		}
		nav.onmouseleave = function () {
			clearTimeout(timer)
			timer = setTimeout(function() {
				nav.classList.remove('top-nav--hover')
			}, 300);
		}
	},

	mainSlider: function () {
		const sliderEl = document.querySelector('.main-banner__slider')
		if (!sliderEl) { return }
		const mySwiper = new Swiper(sliderEl, {
			init: false,
			loop: true,
			effect: 'fade',
			autoplay: {
				delay: 5000,
			},
			pagination: {
				el: '.main-banner__pagination',
				clickable: true,
			},
			lazy: {
				loadPrevNext: true,
				loadOnTransitionStart: true,
			},
		})
		mySwiper.on('init', function() {
			const images = this.$el[0].querySelectorAll('[data-object-fit]')
			APP.objectFitFallback(images);
		});

		mySwiper.init();
	},

	selectionsSlider: function () {
		const sliderEl = document.querySelector('.selections__slider')
		if (!sliderEl) { return }

		const mySwiper = new Swiper(sliderEl, {
			init: false,
			slidesPerView: 3,
			spaceBetween: 20,
			pagination: {
				el: '.selections__pagination',
				clickable: true,
			},
			navigation: {
				nextEl: '.selections__next',
				prevEl: '.selections__prev',
			},
			breakpoints: {
				991: {
					slidesPerView: 2,
				},
				767: {
					slidesPerView: 1,
				}
			}
		})


		const updateLazyload = (swiperData) => {
			APP.myLazyLoad.update();
			const images = swiperData.$el[0].querySelectorAll('[data-object-fit]')
			APP.objectFitFallback(images);
		}
		mySwiper.on('init', function() {
			updateLazyload(this)
		});
		mySwiper.on('slideChange', function() {
			updateLazyload(this)
		});
		mySwiper.init();

	},

	gallerySlider: function  () {
		const sliderEl = document.querySelector('.gallery__slider')
		if (!sliderEl) { return }

		const mySwiper = new Swiper(sliderEl, {
			init: false,
			loop: true,
			slidesPerView: 6,
			spaceBetween: 20,
			navigation: {
				nextEl: '.gallery__next',
				prevEl: '.gallery__prev',
			},
			breakpoints: {
				1799: {
					slidesPerView: 4,
				},
				1359: {
					slidesPerView: 3,
				},
				991: {
					slidesPerView: 2,
				}
			}
		})

		const updateLazyload = (swiperData) => {
			APP.myLazyLoad.update();
			const images = swiperData.$el[0].querySelectorAll('[data-object-fit]')
			APP.objectFitFallback(images);
		}
		mySwiper.on('init', function() {
			updateLazyload(this)
		});
		mySwiper.on('slideChange', function() {
			updateLazyload(this)
		});
		mySwiper.init();
	},

	catalogItemSlider: function () {
		Array.prototype.forEach.call(
			document.querySelectorAll('.item-catalog__slider'), function (item) {
				if (
					item.querySelectorAll('.swiper-slide').length < 2
					|| item.hasClass('swiper-container-initialized')
				) { return }

				const mySwiper = new Swiper(item, {
					init: false,
					spaceBetween: 10,
					navigation: {
						nextEl: item.querySelector('.item-catalog__next'),
						prevEl: item.querySelector('.item-catalog__prev'),
					},
				})
				const updateLazyload = (swiperData) => {
					APP.myLazyLoad.update();
					const images = swiperData.$el[0].querySelectorAll('[data-object-fit]')
					APP.objectFitFallback(images);
				}
				mySwiper.on('init', function() {
					updateLazyload(this)
				});
				mySwiper.on('slideChange', function() {
					updateLazyload(this)
				});
				mySwiper.init();
			})
	},

	catalogDetailedSlider: function () {
		const catalogSlider = document.querySelector('.catalog-elem__slider')
		if (!catalogSlider) { return }

		const slidesLength = catalogSlider.querySelectorAll('.swiper-slide').length
		const galleryThumbs = new Swiper('.catalog-elem__thumbs', {
			init: false,
			spaceBetween: 20,
			slidesPerView: 'auto',
			centeredSlides: true,
			freeMode: true,
			grabCursor: true,
			slideToClickedSlide: true,
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
			breakpoints: {
				767: {
					spaceBetween: 10,
				}
			}
		});

		const updateLazyload = (swiperData) => {
			APP.myLazyLoad.update();
			const images = swiperData.$el[0].querySelectorAll('[data-object-fit]')
			APP.objectFitFallback(images);
		}
		galleryThumbs.on('init', function() {
			updateLazyload(this)
		});
		galleryThumbs.on('slideChange', function() {
			updateLazyload(this)
		});
		galleryThumbs.init();

		const galleryTop = new Swiper(catalogSlider, {
			init: false,
			effect: 'fade',
			lazy: {
				loadPrevNext: true,
				loadOnTransitionStart: true,
			},
			navigation: {
				nextEl: '.catalog-elem__slider-next',
				prevEl: '.catalog-elem__slider-prev',
			},
			keyboard: {
				enabled: true,
			},
			thumbs: {
				swiper: galleryThumbs
			}
		});

		galleryTop.on('init', function() {
			const images = this.$el[0].querySelectorAll('[data-object-fit]')
			APP.objectFitFallback(images);
		});

		galleryTop.init();
	},

	downloadPhotos: function () {

		APP.documentOn('submit', '.js-download-photos', function (e) {
			e.preventDefault()
			const photos = []
			const checkedBoxes = this.querySelectorAll('input[type=checkbox]:checked');
			for (var i = 0; i < checkedBoxes.length; i++) {
				photos.push( checkedBoxes[i].value )
			}
			console.log(photos);
			APP.cache.tingleModal.close()

		})
	},

	Mask: function(selector, regExpString = "+7 (___) ___-__-__") {
		this.elements = document.querySelectorAll(selector)
		this.init = function() {
			listeners(this.elements)
		}

		const listeners = (selector) => {
			for (let i = 0; i < selector.length; i++) {
				const input = selector[i];
				input.addEventListener("input", mask, false);
				input.addEventListener("focus", mask, false);
				input.addEventListener("blur", mask, false);
			}
		}

		const setCursorPosition = function(pos, elem) {
			elem.focus();
			if (elem.setSelectionRange) elem.setSelectionRange(pos, pos);
			else if (elem.createTextRange) {
				const range = elem.createTextRange();
				range.collapse(true);
				range.moveEnd("character", pos);
				range.moveStart("character", pos);
				range.select()
			}
		}


		const mask = function(event) {
			var matrix = regExpString,
				i = 0,
				def = matrix.replace(/\D/g, ""),
				val = this.value.replace(/\D/g, "");
			if (def.length >= val.length) val = def;
			this.value = matrix.replace(/./g, function(a) {
				return /[_\d]/.test(a) && i < val.length ? val.charAt(i++) : i >= val.length ? "" : a
			});
			if (event.type == "blur") {
				if (this.value.length == 2) this.value = ""
			} else {
				setCursorPosition(this.value.length, this)
			}
		}

	},

	feedbackModalForm: function () {
		const onSuccess = function (request) {
			console.log('success');
			APP.cache.tingleModal.close();
		}
		const onError = function () {
			console.log('error');
		}
		APP.documentOn('submit', '#modal-feedback', function (e) {
			e.preventDefault();
			APP.ajaxPost(this, onSuccess, onError)
		})
	},

	loadImagesModalForm: function () {
		const onSuccess = function (request) {
			console.log('success');
		}
		const onError = function () {
			console.log('error');
		}
		APP.documentOn('submit', '#modal-photos', function (e) {
			e.target.submit();
		})
	},

	sendImagesModalForm: function () {
		const onSuccess = function (request) {
			console.log('success');
			APP.cache.tingleModal.close();
		}
		const onError = function () {
			console.log('error');
		}
		APP.documentOn('submit', '#modal-photos-send', function (e) {
			e.preventDefault();
			APP.ajaxPost(this, onSuccess, onError)
		})
	},

	/**
	 * Takes a form node and sends it over AJAX.
	 * @param {HTMLFormElement} form - Form node to send
	 * @param {function} callback - Function to handle onload.
	 *                              this variable will be bound correctly.
	 */
	ajaxPost: function (form, callback, onError) {
		const url = form.action;
		const xhr = new XMLHttpRequest();

		const formData = new FormData(form)

		xhr.open("POST", url);
		xhr.setRequestHeader('X-CSRFToken', APP.getCookie('csrftoken'));

		//.bind ensures that this inside of the function is the XHR object.
		xhr.onload = function() {
			if (xhr.status >= 200 && xhr.status < 400) {
				var resp = xhr.responseText;
				callback(xhr)
			} else {
				console.log('We reached our target server, but it returned an error');
				onError()
			}
		};

		xhr.onerror = function(error) {
			console.log('There was a connection error of some sort');
			onError()
		};

		//All preperations are clear, send the request!
		xhr.send(formData);
	},

	ajaxGet: function (url, callback, onError) {
		const request = new XMLHttpRequest();
		request.open('GET', url, true);

		request.onload = function() {
			if (request.status >= 200 && request.status < 400) {
				callback(request)
			} else {
				// We reached our target server, but it returned an error
				onError ? onError() : console.log('ajaxGet error');
			}
		};

		request.onerror = function() {
			// There was a connection error of some sort
			onError ? onError() : console.log('ajaxGet error');
		};

		request.send();

	},

	getCookie:function (name) {
		var cookieValue = null;
		if (document.cookie && document.cookie !== '') {
			var cookies = document.cookie.split(';');
			for (var i = 0; i < cookies.length; i++) {
				var cookie = cookies[i].trim();
				// Does this cookie string begin with the name we want?
				if (cookie.substring(0, name.length + 1) === (name + '=')) {
					cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
					break;
				}
			}
		}
		return cookieValue;
	},

	/**
	 * показать модаклу с ajax вызовом
	 * @param  {object} object параметры вызова
	 *                         url: string
	 *                         data: object
	 *                         type: string (GET / POST)
	 *                         customClass: array (elements - string)
	 *                         onOpen: function (вызывается после аякса при открытии)
	 *                         onClose: function (вызывается после закрытия)
	 * @return {object}        возвращает объект модалки
	 */
	ajaxModal: function(object) {
		object = object ? object : {}
		object.url = object.url ? object.url : 'string'
		object.data = object.data ? object.data : {}
		object.type = object.type ? object.type : 'GET'
		object.customClass = object.customClass ? object.customClass : []

		const init = () => {
			if (APP.cache.tingleModal) {
				getModalContent(object.url, object.type, object.data)
				return APP.cache.tingleModal
			} else {
				APP.cache.tingleModal = createModal();
				setPreloaderContent();
				APP.cache.tingleModal.open();
				getModalContent(object.url, object.type, object.data)
				return APP.cache.tingleModal
			}
		}

		const createModal = () => {
			const modal = new tingle.modal({
				closeMethods: ['overlay', 'button', 'escape'],
				closeLabel: "Закрыть",
				cssClass: object.customClass ? object.customClass : [],
				beforeOpen: function () {
					document.body.style.marginRight = APP.getScrollbarSize() + 'px';
				},
				beforeClose: function () {
					document.body.removeAttribute("style");
					return true;
				},
				onClose: function() {
					modal.destroy();
					if (object.onClose) { object.onClose() }
					delete APP.cache.tingleModal;
				}
			});

			return modal
		}

		const getModalContent = function (url, type, data) {
			const tingle = APP.cache.tingleModal
			tingle.modal.classList.add('tingle-modal--loading')

			var request = new XMLHttpRequest();
			request.open(type, url, true);

			if (type === 'POST') {
				request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
			}

			request.onload = function() {
				if (request.status >= 200 && request.status < 400) {
					// Success!
					setModalContent(request.responseText)
				} else {
					// We reached our target server, but it returned an error
					if (request.status) {
						const errorMessage = `<b>${request.status}</b>, ${request.statusText}`;
						setErrorContent(errorMessage);
					} else {
						console.log(request);
					}
				}
			};

			request.onerror = function(error) {
				const errorMessage = `<b>undefined</b><p>Пожалуйста, проверьте подключение к интернету.</p>`;
				setErrorContent(errorMessage);
				console.log(error);
			};

			data ? request.send(data) : request.send();
		}

		const setModalContent = (data) => {
			const tingle = APP.cache.tingleModal
			tingle.setContent( data );
			tingle.modal.classList.remove('tingle-modal--loading')
			APP.modalCloseListener( tingle );
			if (object.onOpen) {
				object.onOpen(tingle)
			}
		}

		const setPreloaderContent = () => {
			APP.cache.tingleModal.setContent(`<div class="text-center tingle-modal__loader js-modal-close">
				<svg width="1em" height="1em" class="animation-rotate">
					<use xlink:href="#si-loader" />
				</svg>
			</div>`);
		}

		const setErrorContent = (text) => {
			APP.cache.tingleModal.setContent(`<div class="text-center tingle-modal__ajax-error js-modal-close">
				<i class="fa fa-exclamation-circle ml-2"></i>
				Ошибка: ${text}
			</div>`);
		}

		init();

	},

	modalCloseListener: (modalObject) => {
		modalObject.modalBoxContent.addEventListener('click', function (e) {
			if (e.target == modalObject.modalBoxContent) {
				modalObject.close();
			}
		})
	},

	lazyload: function() {
		if (typeof APP.myLazyLoad == 'undefined') {
			_regularInit()
		} else {
			_update()
		}

		function _update() {
			// console.log('LazyLoad update');
			APP.myLazyLoad.update();
			APP.objectFitFallback(document.querySelectorAll('[data-object-fit]'));
		}

		function _regularInit() {
			// console.log('LazyLoad first init');
			APP.myLazyLoad = new LazyLoad({
				elements_selector: ".lazyload",
				callback_error: function(el) {
					el.parentElement.classList.add('lazyload-error')
				}
			});
			APP.objectFitFallback(document.querySelectorAll('[data-object-fit]'));
		}
	},

	documentOn: function (eventName, selectorStr, callback) {
		const thatElement = (element, selector) => {
			const className = selector.replace('.', '');
			const closestElem = element.closest(selector)
			if ( element.hasClass(className) ) {
				return element
			} else if (closestElem) {
				return closestElem
			} else {
				return false
			}
		}

		document.addEventListener(eventName, function (event) {

			const elem = thatElement(event.target, selectorStr)
			if (elem) {
				const cb = callback.bind(elem)
				cb(event, elem)
			}
		})
	},

	objectFitFallback: function(selector) {
		if ('objectFit' in document.documentElement.style === false) {
			console.log('objectFit Fallback');
			for (var i = 0; i < selector.length; i++) {
				const that = selector[i]
				const imgUrl = that.getAttribute('src');
				const dataFit = that.getAttribute('data-object-fit')
				let fitStyle
				if (dataFit === 'contain') {
					fitStyle = 'contain'
				} else if (dataFit === 'cover') {
					fitStyle = 'cover'
				} else {
					fitStyle = 'auto'
				}
				const parent = that.parentElement
				if (imgUrl) {
					parent.style.backgroundImage = 'url(' + imgUrl + ')'
					parent.style.backgroundSize = fitStyle
					parent.classList.add('fit-img')
				}
			};
		}
	},

	initMap: function () {
		if (document.querySelector('#map')) {
			ymaps.ready(init);
		}

		function init() {
			const markers = [{
				id: 1,
				latLng: [55.756001, 37.643255],
				hintContent: 'Москва, Хохловский переулок 7-9, строение 2, офис 213',
				balloonContent: '<p>г. Москва, Хохловский переулок 7-9, строение 2, офис 213</p>',
			}]
			const markerIcon = document.getElementById('map').getAttribute('data-icon')
			const iconSize = {
				default: [53, 79],
			}
			const latLng = markers[0].latLng
			const myMap = new ymaps.Map("map", {
				center: latLng,
				zoom: 14,
				controls: ['zoomControl']
			});
			myMap.behaviors.disable('scrollZoom')

			const myCollection = new ymaps.GeoObjectCollection({}, {
				iconLayout: 'default#image',
				iconImageHref: markerIcon,
				iconImageSize: iconSize.default,
				iconImageOffset: iconOffset(iconSize.default)
			});


			for (let i = 0; i < markers.length; i++) {
				const marker = markers[i]
				myCollection.add( new ymaps.Placemark(marker.latLng, {
					hintContent: marker.hintContent,
					balloonContent: marker.balloonContent
				}) );
			}
			myMap.geoObjects.add(myCollection)
			if (markers.length > 1) {
				myMap.setBounds(myMap.geoObjects.getBounds())
			}

		}

		/**
		 * Смещение левого верхнего угла иконки относительно её "ножки" (точки привязки).
		 * @param  {array} size размер иконки
		 * @return {array}      смещение относительно размера
		 */
		function iconOffset(size) {
			const offset = []
			offset[0] = size[0] / 2 * -1
			offset[1] = size[1] * -1
			return offset
		}
	},

	isScrolledIntoView: function (el, offset) {
		offset = offset ? offset : 0
		var rect = el.getBoundingClientRect();
		var elemTop = rect.top;
		var elemBottom = rect.bottom;

		var isVisible = (elemTop >= 0) && (elemBottom - offset <= window.innerHeight);
		return isVisible;
	},


	svgIcons: function () {
		const container = document.querySelector('[data-svg-path]')
		const path = container.getAttribute('data-svg-path')
		const xhr = new XMLHttpRequest()
		xhr.onload = function() {
			container.innerHTML = this.responseText
		}
		xhr.open('get', path, true)
		xhr.send()
	},

	polyfills: function () {
		/**
		 * polyfill for .closest
		 */
		(function(ELEMENT) {
			ELEMENT.matches = ELEMENT.matches || ELEMENT.mozMatchesSelector || ELEMENT.msMatchesSelector || ELEMENT.oMatchesSelector || ELEMENT.webkitMatchesSelector;
			ELEMENT.closest = ELEMENT.closest || function closest(selector) {
				if (!this) return null;
				if (this.matches(selector)) return this;
				if (!this.parentElement) {return null}
					else return this.parentElement.closest(selector)
				};
		}(Element.prototype));

		Element.prototype.hasClass = function(className) {
			return this.className && new RegExp("(^|\\s)" + className + "(\\s|$)").test(this.className);
		};
	},

	viewportFix: function () {
		if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
			var ww = (window.innerWidth < window.screen.width) ? window.innerWidth : window.screen.width; //get proper width
			var mw = 375; // min width of site
			var ratio = ww / mw; //calculate ratio
			if (ww < mw) { //smaller than minimum size
				document.getElementById('viewport').setAttribute('content', 'initial-scale=' + ratio + ', minimum-scale=' + ratio + ', user-scalable=yes, width=' + ww)
			}
		}
	},

	getScrollbarSize: function () {
		var scrollbarSize = void 0;
		if (scrollbarSize === undefined) {
			var scrollDiv = document.createElement('div');
			scrollDiv.style.cssText = 'width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;';
			document.body.appendChild(scrollDiv);
			scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
			document.body.removeChild(scrollDiv);
		}
		return scrollbarSize;
	},

	detectIE: function() {
		/**
		 * detect IE
		 * returns version of IE or false, if browser is not Internet Explorer
		 */

		 (function detectIE() {
		 	var ua = window.navigator.userAgent;

		 	var msie = ua.indexOf('MSIE ');
		 	if (msie > 0) {
				// IE 10 or older => return version number
				var ieV = parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
				document.querySelector('body').className += ' IE';
			}

			var trident = ua.indexOf('Trident/');
			if (trident > 0) {
				// IE 11 => return version number
				var rv = ua.indexOf('rv:');
				var ieV = parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
				document.querySelector('body').className += ' IE';
			}

			var edge = ua.indexOf('Edge/');
			if (edge > 0) {
				// IE 12 (aka Edge) => return version number
				var ieV = parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
				document.querySelector('body').className += ' IE';
			}

			// other browser
			return false;
		})();
	},

	throttle: function (callback, limit) {
		var wait = false;
		return function() {
			if (!wait) {
				callback.call();
				wait = true;
				setTimeout(function() {
					wait = false;
				}, limit);
			}
		};
	},

	getScreenSize: function() {
		let screenSize =
			window
			.getComputedStyle(document.querySelector('body'), ':after')
			.getPropertyValue('content');
		screenSize = parseInt(screenSize.match(/\d+/));
		return screenSize;
	},

	pjaxInit: function() {
		pjax = new Pjax({
			elements: ['.demo-menu__link', '.js-pjax'],
			selectors: [".wrap-site", "title"],
			cacheBust: false
		})

		document.body.classList.add('pjax-inited', 'pjax-loaded')
	},

	pjaxListeners: function() {
		document.addEventListener("pjax:send", function() {
			document.body.classList.add('pjax-loading')
			document.body.classList.remove('pjax-loaded')
			topbar.show()
			APP.removeGlobalListeners();
		})

		document.addEventListener("pjax:complete", function() {})

		document.addEventListener("pjax:error", function() {})

		document.addEventListener("pjax:success", function() {
			setTimeout(function() {
				document.body.classList.remove('pjax-loading')
				document.body.classList.add('pjax-loaded')
			}, 10);
			APP.initPage()
			APP.initOnLoad()
		})
	},
};

APP.initOnceBefore();

document.addEventListener('DOMContentLoaded', function() {
	APP.initOnceLayout();
	APP.initPage();
});

window.onload = function() {
	APP.initOnLoad();
};
